import React from 'react'
import { t } from 'ttag'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { updateSelectedFilters } from 'store/actions/filters'
import Button from 'components/ui/Button'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'

function DocumentLanguages({ type, filterData, values, title, onClose, showFilter, customTop }) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters

  const selectedValues = filters.selectedFilters[currentSearchable][type][values[0]]

  const options = []

  Object.entries(filterData).forEach(([key, value]) => {
    const parentOption = {
      label: value,
      value: key,
      expanded: true
    }
    const selectedOption = selectedValues.filter(s => s.id === key && s.label === value)
    if (selectedOption.length > 0) {
      parentOption.checked = true
    }
    options.push(parentOption)
  })

  const onChange = (currentNode, selectedNodes) => {
    const filterValue = selectedNodes.map(node => ({
      id: node.value,
      label: node.label
    }))
    const ids = selectedNodes.map(node => node.value)
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))

    const idData = {
      filterType: 'documents',
      filterId: 'languages',
      filterValue: ids
    }
    dispatch(updateSelectedFilters(idData))
  }

  function handleFilterRemove(filterId, filterValue) {
    const resultingValue = filters.selectedFilters[currentSearchable][type][filterId].filter(
      s => s.id !== filterValue.id || s !== filterValue
    )

    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))

    const resultingIdsValue = filters.selectedFilters[currentSearchable][type].languages.filter(
      s => s !== filterValue.id
    )
    const idsData = {
      filterType: 'documents',
      filterId: 'languages',
      filterValue: resultingIdsValue
    }
    dispatch(updateSelectedFilters(idsData))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filters.selectedFilters[currentSearchable][type][value]) {
        const filterValue = filters.selectedFilters[currentSearchable][type][value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
              <SelectedFilter>
                <FilterText title={v.label ? v.label : v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.label ? v.label : v}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }
  return (
    <>
      <SearchFilter open={showFilter} customTop={customTop}>
        <FilterTitle>{title}</FilterTitle>
        <CustomDropDownTreeSelect data={options} onChange={onChange} />
        <Button size="medium" onClick={onClose}>
          {t`Close`}
        </Button>
      </SearchFilter>
      <div>{renderSelectedValues()}</div>
    </>
  )
}

DocumentLanguages.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.object,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string
}

export default DocumentLanguages
